//\components\TimerInlinePicker.tsx
import { useState, useRef, useEffect } from "react";
import styles from "./TimerInlinePicker.module.css";

interface TimerInlinePickerProps {
  hours: number;
  minutes: number;
  setHours: (val: number) => void;
  setMinutes: (val: number) => void;
  onSet: () => void;
}

function CustomSelect({
  value,
  onChange,
  options,
  label,
}: {
  value: number;
  onChange: (val: number) => void;
  options: number[];
  label: string;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={styles.selectWrapper} ref={ref}>
      <button
        className={styles.trigger}
        onClick={() => setOpen((prev) => !prev)}
      >
        {value} {label}
      </button>
      {open && (
        <ul className={styles.dropdown}>
          {options.map((opt) => (
            <li
              key={opt}
              className={`${styles.option} ${opt === value ? styles.active : ""}`}
              onClick={(e) => {
                e.stopPropagation(); // блокируем всплытие
                onChange(opt);
                setOpen(false);
              }}
            >
              {opt}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
export default function TimerInlinePicker({
  hours,
  minutes,
  setHours,
  setMinutes,
  onSet,
}: TimerInlinePickerProps) {
  return (
    <div className={styles.wrapper}>
      <CustomSelect
        value={hours}
        onChange={setHours}
        options={[...Array(13)].map((_, i) => i)}
        label="hr"
      />
      <CustomSelect
        value={minutes}
        onChange={setMinutes}
        options={[...Array(60)].map((_, i) => i)}
        label="min"
      />
      <button className={styles.setButton} onClick={onSet}>
        Set
      </button>
    </div>
  );
}


